import {FC, useState} from 'react'
import Address from '../../shared/customer/Address'
import CustomerAddressDialog from './CustomerAddressDialog'
import CustomButton from './CustomButton'
import {hideLoader} from 'app/redux/loaderSlice'
import {useDispatch} from 'react-redux'
import clsx from 'clsx'
import CustomerAddressDialogV1 from 'app/features/orders/orderEdit/edit/components/Address/CustomerAddressDialog'

interface Props {
  title: string
  isEditMode: boolean
  address: any
  customerId: string
  onChangeAddress?: (address: any) => void
  isDraftOrder?: boolean
}

export const AddressAction: FC<Props> = ({
  title,
  isEditMode,
  address,
  customerId,
  onChangeAddress,
  isDraftOrder,
}) => {
  const dispatch = useDispatch()

  const [showADialog, setShowDialog] = useState(false)

  const handleOpenDialog = () => {
    setShowDialog(true)
  }

  // const addressList = useSelector<RootState, any[]>(({orders}) => orders.customer.customerAddress)

  const close = () => {
    dispatch(hideLoader())
    setShowDialog(false)
  }

  const handleClose = () => {
    close()
    // if (isEditMode && address && address.id && onChangeAddress) {
    //   const adr = find(addressList, {id: address.id})
    //   if (adr) {
    //     onChangeAddress(adr)
    //   }
    // }
  }

  const handleAddressChange = (address: any) => {
    if (onChangeAddress) {
      onChangeAddress(address)
    }
    close()
  }

  return (
    <div className='d-flex flex-column'>
      <div
        className={clsx(
          'd-flex align-items-center fs-5 fw-bolder justify-content-between',
          !isEditMode && 'mb-2 pt-2'
        )}
      >
        {title}
        {isEditMode && (
          <CustomButton onClick={handleOpenDialog}>
            {address && address.id ? 'Change' : 'Create'}
          </CustomButton>
        )}
      </div>
      <Address address={address} shippingTab={title === 'Shipping Address'} />
      {showADialog && (
        <>
          {isDraftOrder ? (
            <CustomerAddressDialog
              onClose={handleClose}
              customerId={customerId}
              selectedAddress={address?.id}
              onChangeAddress={handleAddressChange}
            />
          ) : (
            <CustomerAddressDialogV1
              onClose={handleClose}
              customerId={customerId}
              selectedAddress={address?.id}
              onChangeAddress={handleAddressChange}
            />
          )}
        </>
      )}
    </div>
  )
}

export default AddressAction
